import React from "react";
import { Pressable, View } from "react-native";
import Text from "@/components/shared/AppText";
import { brandColor, buttonGrayLight } from "../globalStyle";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";

const AppRadio = ({ label, selected, onSelect, icon, highlight }) => (
  <Pressable
    style={[
      tw`flex-row w-full py-[10px] rounded-[16px]`,
      highlight && selected ? tw`border border-[#3f5b7a] bg-white` : undefined,
    ]}
    onPress={onSelect}
  >
    {!icon && (
      <Pressable
        onPress={onSelect}
        style={[
          tw`w-[21px] h-[21px] mr-[11px] rounded-full border-2 items-center justify-center`,
          selected
            ? tw`border-[${brandColor}]`
            : tw`border-[${buttonGrayLight}]`,
          highlight ? tw`ml-5` : undefined,
        ]}
      >
        {selected && (
          <View style={tw`w-[11px] h-[11px] rounded-full bg-[${brandColor}]`} />
        )}
      </Pressable>
    )}

    {icon && <Ionicons name={icon} size={30} style={tw`ml-5`} />}
    <Text
      style={
        icon
          ? tw`flex-1 flex-grow ml-[21px] p-[2px] pt-[7px]`
          : tw`flex-1 flex-grow ml-[21px] p-[2px]`
      }
    >
      {label}
    </Text>
  </Pressable>
);

export default AppRadio;
